<template>
  <div class="sortable-list">
    <draggable
      :value="valueList"
      group="items"
      handle=".sortable-list-item"
      :style="{
        height: heightValue,
        overflow: heightValue ? 'scroll' : 'unset',
      }"
      animation="200"
      ghost-class="sortable-ghost"
      chosen-class="sortable-chosen"
      drag-class="sortable-drag"
      @start="drag = true"
      @end="drag = false"
      @input="updateListOrder"
    >
      <div
        v-for="element in valueList"
        :key="element.value"
      >
        <v-row
          no-gutters
          class="sortable-list-item"
        >
          <div>
            <v-icon
              :size="20"
              class="mr-1 mt-2"
            >
              $icon_drag_and_drop
            </v-icon>
          </div>
          <div class="component-wrapper">
            <component
              :is="element.component"
              v-bind="element.props"
              v-on="element.events"
            />
          </div>
        </v-row>
      </div>
    </draggable>
  </div>
</template>

<script setup lang="ts">
// This component accepts a list of component items with props and methods, and supports drag-and-drop reordering.
import { AsyncComponent, computed, ref } from 'vue';
import draggable from 'vuedraggable';

// Type for each Item in array
export type ListItem = {
  text: string;
  value: string;
  component: AsyncComponent | Element;
  props?: object;
  events?: { [key: string]: (value?: object) => void };
};

const props = withDefaults(
  defineProps<{
    value: ListItem[];
    height?: string | number;
  }>(),
  {
    height: undefined,
  }
);

const emit = defineEmits<{
  (e: 'input', value: ListItem[]): void;
}>();

const drag = ref(false);
const heightValue = computed(() => (typeof props.height === 'number' ? props.height + 'px' : props.height));

const valueList = computed({
  get: () => props.value,
  set: (newValue) => {
    if (newValue !== props.value) {
      emit('input', newValue);
    }
  },
});

const updateListOrder = (list: ListItem[]) => {
  valueList.value = list;
};
</script>

<style lang="scss" scoped>
.component-wrapper {
  flex: 1;
}

.sortable-list {
  margin-top: -8px;
}

.sortable-list-item {
  margin: 20px 12px;
}
</style>
